"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWindowDimensions = void 0;

var getWindowDimensions = function getWindowDimensions() {
  return window.innerHeight && window.innerWidth ? {
    px_width: Math.round(window.innerWidth),
    px_height: Math.round(window.innerHeight)
  } : undefined;
};

exports.getWindowDimensions = getWindowDimensions;